(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('employee-customer-sector', {
            parent: 'entity',
            url: '/employee-customer-sector?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employeeCustomerSector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sectors.html',
                    controller: 'EmployeeCustomerSectorController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeeCustomerSector');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('employee-customer-sector-detail', {
            parent: 'entity',
            url: '/employee-customer-sector/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.employeeCustomerSector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-detail.html',
                    controller: 'EmployeeCustomerSectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('employeeCustomerSector');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EmployeeCustomerSector', function($stateParams, EmployeeCustomerSector) {
                    return EmployeeCustomerSector.get({id : $stateParams.id});
                }]
            }
        })
        .state('employee-customer-sector.new', {
            parent: 'employee-customer-sector',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-dialog.html',
                    controller: 'EmployeeCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                myTarget: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('employee-customer-sector');
                });
            }]
        })
        .state('employee-customer-sector.edit', {
            parent: 'employee-customer-sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-dialog.html',
                    controller: 'EmployeeCustomerSectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EmployeeCustomerSector', function(EmployeeCustomerSector) {
                            return EmployeeCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('employee-customer-sector.delete', {
            parent: 'employee-customer-sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/employee-customer-sector/employee-customer-sector-delete-dialog.html',
                    controller: 'EmployeeCustomerSectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EmployeeCustomerSector', function(EmployeeCustomerSector) {
                            return EmployeeCustomerSector.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('employee-customer-sector', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
